import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, storePath } from '@/lib/api-client';
import type { StoreListing } from '@/types/store';

import { storeKeys } from './store-keys';

/** GET /admin/store-metadata/listings — every listing row (all platforms/locales). */
export function useStoreListings(): UseQueryResult<StoreListing[], Error> {
  return useQuery({
    queryKey: storeKeys.listings(),
    queryFn: ({ signal }) => apiClient.get<StoreListing[]>(storePath('/listings'), signal),
  });
}
